<!-- One stack, mounted once at the app root. Hovering anywhere on it pauses
     every countdown, so a message can be read — or its Undo reached — without
     racing the timer.

     Pointer events, not mouse events: `hold()` has to know whether the pointer
     is one that can hover, and only a PointerEvent carries that. Binding both
     would defeat it — a tap fires the emulated mouse pair straight after the
     pointer pair. `pointercancel` matters because a touch-scroll that starts on
     the stack ends there and never sends `pointerleave`. -->
@if (notify.notices().length) {
  <div class="nt-stack"
       (pointerenter)="hold($event)"
       (pointerleave)="release()"
       (pointercancel)="release()">
    @for (notice of notify.notices(); track notice.id) {
      <app-notice-card [notice]="notice" [paused]="paused"
                       (dismissed)="notify.dismiss(notice.id)"
                       (acted)="notify.runAction(notice)"/>
    }
  </div>
}
